import { IconHelpSquareRounded } from "@tabler/icons-react";
import withIconSize from "./hoc/withIconSize";
import { InternalIconProps } from "./types/SvgIconProps";

interface Props extends InternalIconProps {
  className?: string;
}

const AppHelpIcon = (props: Props) => {
  const { className, ...rest } = props;

  return <IconHelpSquareRounded {...rest} className={props.className} />;
};
export default withIconSize(AppHelpIcon);
